import { createSelector } from '@reduxjs/toolkit'

import { getRates } from '../root.selectors'

export const getNBGRates = createSelector(getRates, (slice) => slice.nbg)
export const getCommercialRates = createSelector(getRates, (slice) => slice.commercial)
